import React from "react";

interface Props {
    title: string
    icon: React.ReactNode
    className?: string
}

export const CtModalHeader = ({title, icon, className}: Props): React.ReactElement => (
    <div className={`df-ct-header ${className}`}>
        {icon}
        <h4>{title}</h4>
    </div>
);

CtModalHeader.defaultProps = {
    className: "",
};
